export function ipfsToHttp(ipfsUrl, gatewayBase) {
  if (!ipfsUrl || typeof ipfsUrl !== "string") return ipfsUrl;

  // Already a normal URL or relative path
  if (
    ipfsUrl.startsWith("http://") ||
    ipfsUrl.startsWith("https://") ||
    ipfsUrl.startsWith("/")
  ) {
    return ipfsUrl;
  }

  const gateway =
    gatewayBase ||
    process.env.REACT_APP_IPFS_GATEWAY ||
    "https://ipfs.io/ipfs/";

  // Normalize `ipfs://...`
  let rest = ipfsUrl;
  if (rest.startsWith("ipfs://")) rest = rest.slice("ipfs://".length);
  if (rest.startsWith("ipfs/")) rest = rest.slice("ipfs/".length);

  // `rest` is now like: <cid>/<path> OR <cid>
  const base = gateway.endsWith("/") ? gateway : `${gateway}/`;
  return `${base}${rest}`;
}

